import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { inr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Plus, Copy, Trash2, Pencil } from "lucide-react";

const STATUS_CLS = { ACTIVE: "text-teal-400", UPCOMING: "text-amber-400", HIDDEN: "text-slate-500", SOLD_OUT: "text-red-400", DISCONTINUED: "text-slate-600", PRE_LAUNCH: "text-blue-400" };

export default function AdminProducts() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data: products, isLoading } = useQuery({ queryKey: ["admin-products"], queryFn: async () => (await api.get("/admin/products")).data });

  const duplicate = async (id) => { await api.post(`/admin/products/${id}/duplicate`); qc.invalidateQueries(["admin-products"]); toast.success("Product duplicated"); };
  const del = async (id) => { if (!window.confirm("Delete this product?")) return; const { data } = await api.delete(`/admin/products/${id}`); qc.invalidateQueries(["admin-products"]); toast.success(data.message); };

  if (isLoading) return <Loader2 className="w-8 h-8 animate-spin text-teal" />;
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Products</h1>
        <Button className="bg-teal hover:bg-teal-dark text-white gap-1" onClick={() => navigate("/admin/products/new")} data-testid="admin-new-product"><Plus className="w-4 h-4" /> New Product</Button>
      </div>
      <div className="bg-slate-900 border border-white/10 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-800/50 text-slate-400 text-xs uppercase">
            <tr><th className="text-left px-4 py-3">Product</th><th className="text-left px-4 py-3 hidden sm:table-cell">Type</th><th className="text-left px-4 py-3">Price</th><th className="text-left px-4 py-3">Status</th><th className="text-right px-4 py-3">Actions</th></tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {products.map((p) => (
              <tr key={p.id} className="hover:bg-white/5" data-testid={`admin-product-${p.slug}`}>
                <td className="px-4 py-3"><div className="font-medium text-white">{p.name}</div><div className="text-xs text-slate-500">{p.sku}</div></td>
                <td className="px-4 py-3 hidden sm:table-cell text-slate-400">{p.type}</td>
                <td className="px-4 py-3 text-white">{inr(p.offer_price || p.price)}</td>
                <td className={`px-4 py-3 font-medium ${STATUS_CLS[p.status] || "text-slate-400"}`}>{p.status}</td>
                <td className="px-4 py-3">
                  <div className="flex justify-end gap-1">
                    <button onClick={() => navigate(`/admin/products/${p.id}`)} className="p-2 text-slate-400 hover:text-teal-400" data-testid={`edit-${p.slug}`}><Pencil className="w-4 h-4" /></button>
                    <button onClick={() => duplicate(p.id)} className="p-2 text-slate-400 hover:text-white"><Copy className="w-4 h-4" /></button>
                    <button onClick={() => del(p.id)} className="p-2 text-slate-400 hover:text-red-400"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
